import axios from 'axios/lib/axios';

const base = '/api/v1/customer/';
const modelBase = '/api/v1/model/';
const timeout = 30000;

const endpoints = {
  getTenancy: function () {
    return axios.get(`${base}tenancy`, {
      timeout: timeout,
    });
  },
  getCustomerData: function () {
    return axios.get(`${modelBase}customerData`, {
      timeout: timeout,
    });
  },
  getAccount: function (tenancyRef) {
    return axios.get(`${base}accounts`, {
      params: {
        ref: tenancyRef,
      },
      timeout: timeout,
    });
  },
  getLetters: function (tenancyRef) {
    return axios.get(`${base}letters`, {
      params: {
        ref: tenancyRef,
      },
      timeout: timeout,
    });
  },
  getLetter: function (tenancyRef, letterId) {
    return axios.get(`${base}letters/${letterId}`, {
      params: {
        ref: tenancyRef,
      },
      timeout: timeout,
    });
  },
  getAppointments: function (tenancyRef) {
    return axios.get(`${base}appointments`, {
      params: {
        ref: tenancyRef,
      },
      timeout: timeout,
    });
  },
  getTransactions: function (tenancyRef, paymentRef) {
    return axios.get(`${base}transactions`, {
      params: {
        ref: tenancyRef,
        paymentRef: paymentRef,
      },
      timeout: timeout,
    });
  },
  getWorkRequests: function (propertyReference, status) {
    const params = {
      ref: propertyReference,
    };

    if (status) {
      params.status = status.toUpperCase();
    }

    return axios.get(`${base}work-requests`, {
      params,
      timeout: timeout,
    });
  },
  createArrangement: function (data, tenancyRef) {
    data['tenancyRef'] = tenancyRef;
    return axios.post(`${base}arrangements`, data, {
      timeout: timeout,
    });
  },
  getBankDetails: function () {
    return axios.get(`${base}bank-details`, {
      timeout: timeout,
    });
  },
  deleteBankDetails: function (accountID) {
    return axios.delete(`${base}bank-details/` + accountID, {
      timeout: timeout,
    });
  },
  createBankDetails: function (data) {
    return axios.post(`${base}bank-details`, data, {
      timeout: timeout,
    });
  },
  updateBankDetails: function (accountId, data) {
    return axios.put(`${base}bank-details/` + accountId, data, {
      timeout: timeout,
    });
  },
  getContactDetails: function () {
    return axios.get(`${base}contact-details`, {
      timeout: timeout,
    });
  },
  deleteContact: function (contactId) {
    return axios.delete(`${base}contact-details/` + contactId, {
      timeout: timeout,
    });
  },
  updateContact: function (contactId, data) {
    return axios.put(`${base}contact-details/` + contactId, data, {
      timeout: timeout,
    });
  },
  createConsentedPerson: function (data) {
    return axios.post(`${base}consented-persons`, data, {
      timeout: timeout,
    });
  },
  deleteConsentedPerson: function (consentedPersonId) {
    return axios.delete(`${base}consented-persons/` + consentedPersonId, {
      timeout: timeout,
    });
  },
};

export default endpoints;
